import React, { forwardRef, useState } from "react";

/**
 * A simple wrapper around native text inputs and textareas.
 */
const TextInput = forwardRef(
  (
    {
      label,
      onChange,
      value,
      type,
      area,
      valid = false,
    },
    ref
  ) => {
    const [active, setActive] = useState(false);

    const defaultProps = {
      id: label,
      value: value,
      onFocus: () => setActive(true),
      onBlur: () => setActive(false),
      ref,
      onChange,
      className: valid ? 'valid' : '',
    };

    return (
      <div className={`question-container ${valid ? 'valid' : ''}`}>
        <label
          className="question animated"
          htmlFor={label}
          style={{
            transform: active || value.length > 0 ? "translateY(-100%)" : "none"
          }}
        >
          {label}
        </label>
        {!area && (
          <input
            ref={ref}
            type={type || "text"}
            {...defaultProps}
          />
        )}
        {area && (
          <textarea {...defaultProps} rows={10} />
        )}
      </div>
    );
  }
);

export default TextInput;
